import React, { Component } from "react";

const CannedFoodsIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2159 15.2799C12.6447 15.2799 13.8071 14.1175 13.8071 12.6888C13.8071 11.26 12.6447 10.0977 11.2159 10.0977C9.78714 10.0977 8.62476 11.26 8.62476 12.6888C8.62476 14.1175 9.78714 15.2799 11.2159 15.2799ZM11.2159 11.2695C11.9985 11.2695 12.6352 11.9062 12.6352 12.6888C12.6352 13.4713 11.9985 14.108 11.2159 14.108C10.4333 14.108 9.79663 13.4713 9.79663 12.6888C9.79663 11.9062 10.4333 11.2695 11.2159 11.2695Z"
        fill={fill}
      />
      <path
        d="M18.3987 9.08852V5.3125H13.4864V3.77602H14.3653V0H0V3.77602H0.772148V16.224H0V20H18.3987V16.224H17.5198V9.08852H18.3987ZM17.2268 7.91664H5.20523V6.48438H17.2268V7.91664H17.2268ZM1.17188 1.17188H13.1934V2.60414H1.17188V1.17188ZM1.94402 3.77602H12.3146V5.3125H4.03336V9.08852H4.80555V16.224H1.94402V3.77602ZM1.17188 18.8281V17.3959H4.03336V18.8281H1.17188ZM17.2268 18.8281H5.20523V17.3959H17.2268V18.8281H17.2268ZM16.3479 16.224H5.97742V9.08852H16.3479V16.224Z"
        fill={fill}
      />
    </svg>
  );
};

CannedFoodsIcon.defaultProps = {
  width: 19,
  height: 20,
  fill: "black",
};

export default CannedFoodsIcon;
